import axios from "axios";
import config from "app/api/axiosConfig";
import { IRecordRequest } from "app/api/types";

export default (token: string, data: IRecordRequest) =>
  axios.put(
    `${process.env.REACT_APP_API_HOST}/admin/records`,
    data,
    config(token)
  );
